import React from 'react';
import { Box, Avatar, Typography, IconButton, Chip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ChevronRight } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const ProfileContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  width: '196px',
  borderRadius: '8px',
  cursor: 'pointer',
  transition: 'all 0.2s ease-in-out',
//   '&:hover': {
//     backgroundColor: '#F5F5F5',
//   },
}));

const ProfileAvatar = styled(Avatar)({
  width: '46px',
  height: '46px',
  border: '3px solid #FFFFFF',
});

const UserInfo = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  flex: 1,
  minWidth: 0, // Allows text truncation to work
});

const UserName = styled(Typography)({
  fontWeight: 600,
  fontStyle: 'normal',
  fontSize: '12px',
  lineHeight: '26px',
  letterSpacing: '0%',
  color: '#1D1D1B',
  height: '26px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

const IDChip = styled(Chip)({
  color: '#A9C74E',
  fontFamily: 'Red Hat Display',
  fontWeight: 400,
  fontStyle: 'normal',
  fontSize: '12px',
  lineHeight: '14px',
  letterSpacing: '0%',
  backgroundColor: '#E0EAC8',
  borderRadius: '8px',
  width: '66px',
  height: '22px',
  '& .MuiChip-label': {
    padding: '4px 6px',
  },
});

const ProfileCard = ({ user }) => {
  const navigate = useNavigate();
  
  if (!user || !user.name || !user.id) return null;

  const handleProfileClick = () => {
    navigate('/profile');
  };

  return (
    <ProfileContainer onClick={handleProfileClick}>
      <ProfileAvatar 
        src={user.profilePicture || `https://ui-avatars.com/api/?name=${user.name}&background=B3B3B3&color=fff&size=46`} 
        alt={user.name}
      />
      <UserInfo>
        <IDChip label={`ID ${user.id}`} size="small" />
        <UserName>{user.name}</UserName>
      </UserInfo>
      <IconButton 
        size="small" 
        sx={{ 
          color: '#4A4A49',
        }}
      >
        <ChevronRight sx={{ fontSize: '24px' }} />
      </IconButton>
    </ProfileContainer>
  );
};

export default ProfileCard;
